export default {
  newVersionOf: 'New version of',
  versionNotes: 'Version notes',
  versionNotesPlaceholder: 'e.g. One more year of data added to the previous version',
  noPreviousVersion: 'Leave empty if this model has no previous version',
  willBeVersion: 'This model will be v{version} of {name}',
  isVersion: 'This model is v{version}. Clear the field to unlink it',
  notLatest: 'This model is v{version}. Only the latest version of a family can be unlinked',
  hasOwnVersions: 'This model is the first version of its own family, so it cannot be a version of another model'
}
